
import { Card, CardContent } from '@/components/ui/card';
import { Trophy } from 'lucide-react';

const CongratulatoryMessage = () => {
  return (
    <Card className="shadow-md mb-8 border-2 border-brand-yellow">
      <CardContent className="p-6 flex gap-4 items-center">
        <Trophy className="h-12 w-12 text-brand-yellow shrink-0" />
        <div>
          <h3 className="text-lg font-semibold mb-1">Congratulations on Taking This Important Step!</h3>
          <p className="text-gray-600">
            You've made a significant investment in your future. Our assessment will help you discover your strengths and guide you toward a fulfilling career path.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default CongratulatoryMessage;
